// components/VideoPlayer/WordInfoModal/DefinitionSection.jsx

import React, { useState } from "react";
import "./WordInfoModal.css";

const DefinitionSection = ({ enData }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  if (!enData || enData.length === 0) {
    return null;
  }

  return (
    <div className="definition-section">
      <div
        className="definition-header"
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <h4>English Definitions</h4>
        <span className={`expand-icon ${isExpanded ? "expanded" : ""}`}>
          {isExpanded ? "▼" : "▶"}
        </span>
      </div>

      {isExpanded && (
        <div className="definition-list">
          {enData.map((def, index) => (
            <div key={def._id || index} className="definition-item">
              <span className="def-number">{index + 1}.</span>
              <div className="def-content">
                {def.wordtype && (
                  <span className="def-wordtype">({def.wordtype})</span>
                )}
                <span className="def-text">{def.definition}</span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default DefinitionSection;
